import { Button, Space } from "antd";
import Toolbar from "../v2/shared-components/Toolbar";
import { observer } from "mobx-react-lite";
import labelPrinterStorage from "../storages/labelPrinterStorage";
import LabelIcon from "@ant-design/icons/PrinterOutlined";
import LanguageSwitcher from "../components/LanguageSwitcher";

function MainToolbar() {
  const {
    connectToPrinter,
    disconnectFromPrinter,
    isPrinterConnected,
    btEnabled,
    isPrinting,
  } = labelPrinterStorage;

  const connectionHandler = isPrinterConnected ? disconnectFromPrinter : connectToPrinter;
  const connectionButtonText = isPrinterConnected ? "Disconnect label printer" : "Connect label printer";

  return (
    <Toolbar>
      <Space size="middle">
        {btEnabled && (
          <Button
            onClick={connectionHandler}
            loading={isPrinting}
            type={isPrinterConnected ? "primary" : "default"}
            disabled={isPrinting}
            title={connectionButtonText}
          >
            <LabelIcon />
          </Button>
        )}
        <LanguageSwitcher />
      </Space>
    </Toolbar>
  );
}

export default observer(MainToolbar);
